import React, { useState } from 'react';
import { Alert, Stack, TextField } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { createTruckDriver } from '../../actions/supervisorActions';
import { useAppDispatch, useAppSelector } from '../hooks';

export function CreateTruckDriverDialog() {
  const dispatch = useAppDispatch();

  const truckDriversState = useAppSelector((state) => state.truckDrivers);

  const [didFail, setDidFail] = useState(false);

  const [name, setName] = useState<string>('');
  const [nameProblem, setNameProblem] = useState<string | null>(null);
  function validateName(name: string) {
    if (name == null || name.trim() === '') {
      setNameProblem('Name is required');
      return;
    }

    if (
      Object.values(truckDriversState.truckDrivers).some(
        (existingTruckDriver) => existingTruckDriver.name === name.trim(),
      )
    ) {
      setNameProblem('Truck driver with same name already exists');
      return;
    }

    setNameProblem(null);
    return true;
  }

  async function onSubmit() {
    const nameValidated = validateName(name);
    if (!nameValidated) return;

    setDidFail(false);
    setNameProblem(null);

    try {
      await dispatch(createTruckDriver(name));
    } catch (error) {
      setDidFail(true);

      console.error(error);

      return;
    }

    dispatch(closeCurrentPopup());
  }

  return (
    <Dialog
      title="Create Truck Driver"
      submitText="Create"
      onSubmit={onSubmit}
      onCancel="close"
      enterKeySubmits
      submitDisabled={!!nameProblem}
    >
      <Stack spacing={2} sx={{ marginTop: 1 }}>
        {didFail && (
          <Alert variant="outlined" severity="error">
            Unable to create truck driver.
          </Alert>
        )}

        <TextField
          autoFocus
          autoComplete="off"
          size="small"
          label="Truck Driver Name"
          sx={{ marginTop: 1, width: '400px' }}
          value={name}
          error={!!nameProblem}
          onFocus={(event) => event.target.select()}
          onChange={(event) => {
            setName(event.target.value);
            validateName(event.target.value);
          }}
        />

        {nameProblem && (
          <Alert variant="outlined" severity="error">
            {nameProblem}
          </Alert>
        )}
      </Stack>
    </Dialog>
  );
}
